import { createRoot } from 'react-dom/client';
import axios from 'axios';

import './_metronic/assets/sass/style.scss';
import './_metronic/assets/sass/plugins.scss';
import './_metronic/assets/sass/style.react.scss';
import './app/modules/styles/index.scss';
import { AppRoutes } from './app/routing/AppRoutes';
import { AuthProvider, setupAxios } from './app/modules/auth';
import { MetronicI18nProvider } from './_metronic/i18n/Metronici18n';

setupAxios(axios);

const container = document.getElementById('root');

if (container) {
	createRoot(container).render(
		<MetronicI18nProvider>
			<AuthProvider>
				<AppRoutes />
			</AuthProvider>
		</MetronicI18nProvider>
	);
}
